import stencilReduxGlobalScript from '/agent/_work/14/s/node_modules/@stencil/redux/dist/collection/global/store.js';
import rassStaticsGlobalScript from '/agent/_work/14/s/src/utils/globals.ts';
export const globalScripts = () => {
  rassStaticsGlobalScript();
  stencilReduxGlobalScript();
};
